import React from 'react';
import PropTypes from 'prop-types';
import './TuringHelpBtn.css';

function TuringHelpBtn ({ children, help }) {
  return (
    <span className="TuringHelpBtn">
      <span>{children}</span>
      <span className="TuringHelpBtnIcon">
        <span className="material-icons" aria-hidden="true">help</span>
        <div className="TuringHelpBtncontent">{help}</div>
      </span>
    </span>
  );
}

TuringHelpBtn.propTypes = {
  help: PropTypes.any,
  children: PropTypes.any
};

export default TuringHelpBtn;
